import { render } from "./Activity.vue?vue&type=template&id=0b925d71&scoped=true"
import script from "./Activity.vue?vue&type=script&lang=js"
export * from "./Activity.vue?vue&type=script&lang=js"

import "./Activity.vue?vue&type=style&index=0&id=0b925d71&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0b925d71"

export default script